import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TokenExpirationInfo = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-surface border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="HelpCircle" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-text-primary">¿Cómo funcionan los tokens?</h3>
            <p className="text-sm text-text-secondary">Información sobre tokens de MercadoLibre</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          {isExpanded ? "Ocultar" : "Ver más"}
        </Button>
      </div>

      {isExpanded && (
        <div className="mt-6 space-y-6">
          {/* Token Expiration Explanation */}
          <div className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="Clock" size={18} className="text-primary mt-0.5" />
              <div>
                <h4 className="font-medium text-text-primary mb-2">¿Qué indica la expiración del token?</h4>
                <div className="space-y-2 text-sm text-text-secondary">
                  <p>• <strong>Los tokens de MercadoLibre tienen una duración limitada</strong> por motivos de seguridad</p>
                  <p>• Cuando el token expira, <strong>pierdes acceso a la API</strong> hasta renovar la conexión</p>
                  <p>• La fecha de expiración indica <strong>cuándo necesitarás reconectarte</strong></p>
                  <p>• Los tokens típicamente duran <strong>6 horas desde su creación</strong></p>
                </div>
              </div>
            </div>
          </div>

          {/* Auto-renewal Explanation */}
          <div className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="RefreshCw" size={18} className="text-warning mt-0.5" />
              <div>
                <h4 className="font-medium text-text-primary mb-2">¿Cómo se renueva la conexión?</h4>
                <div className="space-y-2 text-sm text-text-secondary">
                  <p>• MercaBull dispone de una opción para renovar la conexión.</p>
                  <p>• Cuando la renovación se completa correctamente, se actualiza la fecha de expiración.</p>
                  <p>• Si la renovación falla, puedes volver a conectar tu cuenta desde Configuración.</p>
                  <p>• El tiempo restante depende de la fecha real de vencimiento del token.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Warning Alert Explanation */}
          <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="AlertTriangle" size={18} className="text-warning mt-0.5" />
              <div>
                <h4 className="font-medium text-text-primary mb-2">¿Cuándo aparece el aviso de vencimiento?</h4>
                <div className="space-y-2 text-sm text-text-secondary">
                  <p>• El aviso aparece cuando faltan 30 minutos para que expire la conexión.</p>
                  <p>• Puedes cerrar la alerta y seguir viendo el tiempo restante en el contador flotante.</p>
                  <p>• Cuando la conexión expire, aparecerá la opción Ir a configuración.</p>
                  <p>• Al detectarse una renovación válida, el contador desaparecerá.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Status Types */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-success/10 border border-success/20 rounded-lg p-3">
              <div className="flex items-center space-x-2 mb-2">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <span className="text-sm font-medium text-success">Conectado</span>
              </div>
              <p className="text-xs text-text-secondary">Conexión activa y token válido</p>
            </div>

            <div className="bg-warning/10 border border-warning/20 rounded-lg p-3">
              <div className="flex items-center space-x-2 mb-2">
                <Icon name="AlertTriangle" size={16} className="text-warning" />
                <span className="text-sm font-medium text-warning">Expirando Pronto</span>
              </div>
              <p className="text-xs text-text-secondary">La conexión se acerca a su vencimiento</p>
            </div>

            <div className="bg-error/10 border border-error/20 rounded-lg p-3">
              <div className="flex items-center space-x-2 mb-2">
                <Icon name="XCircle" size={16} className="text-error" />
                <span className="text-sm font-medium text-error">Token Expirado</span>
              </div>
              <p className="text-xs text-text-secondary">Reconexión requerida inmediatamente</p>
            </div>
          </div>

          {/* Best Practices */}
          <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="Lightbulb" size={18} className="text-primary mt-0.5" />
              <div>
                <h4 className="font-medium text-text-primary mb-2">Mejores prácticas</h4>
                <div className="space-y-1 text-sm text-text-secondary">
                  <p>• Revisa el estado de conexión antes de operaciones importantes</p>
                  <p>• Revisa el contador y renueva la conexión antes de su vencimiento</p>
                  <p>• Mantén tus credenciales guardadas para reconexión rápida</p>
                  <p>• Usa "Probar Conexión" si tienes dudas sobre el estado</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TokenExpirationInfo;